<div class="notice">
  <img src="../../../../../assets/images/pre-purchase.png" alt="" />
  <div class="title">购买前请务必阅读</div>
  <div class="subtitle">
    由于家庭组订阅的特殊性，为避免后续糾纷，<br />请您确认知晓以下风险：
  </div>
  <div class="content" mat-dialog-content>
    <div class="item">
      <div class="txt1"><span></span>可能中途停用：</div>
      <div class="txt2">
        谷歌风控可能导致家庭组解散。如遇此情况，我们将提供售后（补时长），但无法保证100%不中断。
      </div>
    </div>
    <div class="item">
      <div class="txt1"><span></span>可能需要换号：</div>
      <div class="txt2">
        极端情况下（如谷歌限制），由于谷歌规则限制（一年只能换一次家庭），您可能需要提供全新的谷歌邮箱加入新组。
      </div>
    </div>
    <div class="item">
      <div class="txt1"><span></span>售后保障：</div>
      <div class="txt2">
        我们承诺提供质保服务，但请理解这是拼车服务的固有特性。
      </div>
    </div>
  </div>
  <div class="button">
    <button matRipple (click)="onOk()">我已知晓风险，继续支付</button>
  </div>
</div>
